import React, { Component } from 'react'
import { Button, } from 'antd';
import { getcodeValue} from '@/utils/storage'
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"

export default class eduInlineDetail extends Component {
    
    state={
        courseInfo:{},
        courseList:[],
        TraList:[]
    }

    componentDidMount(){
        console.log('看一下有哪些信息',this.props);
        let sourseId = this.props.location.pathname.split('/').slice(-1)
        this.getDetail(sourseId[0])
    }
    getVideoUrl=(url)=>{
        console.log('urlurlurlurlurlurl',url);
        if(url){
            console.log('22222222',url.split('/')[1]);
            
            if(url.split('/')[1] == 'fileservice'){
                console.log('fileservicefileservicefileservice',url.substring(url.indexOf("/",url.indexOf("/") + 1)));
                url = `http://192.168.1.6:8888${url.substring(url.indexOf("/",url.indexOf("/") + 1))}`
            }
        }
        return url
        // courseInfo.videoUrl
    }
    //获取详情
    getDetail = (data) =>{
        // console.log('id信息',data);
        let params = {
            id : data
        }
        Http.getApplication(Request.eduDetail(),{...params},(obj)=>{
            console.log(obj);
            if(obj.code == 200){
                if(obj.data.videoUrl){
                    obj.data.videoUrl  = this.getVideoUrl(obj.data.videoUrl)
                }
               this.setState({
                   courseInfo:obj.data,
                   courseList:obj.data.records
               })
            }
       })
    } 
    render() {
        const {courseInfo,TraList} =this.state

        return (
            <div >
                <div className='eduInlineDetail'>
                    <div className='conBox'>
                        <div className='videoBox'>
                            <div className='video'>
                                <video width="320" height="240" autoPlay='autoPlay' controls>
                                    {/* <source src='http://192.168.1.6:8888/group1/M00/00/30/wKgBBmKr656EHSYeAAAAAG0f_xE270.MP4'type="video/mp4"/> */}
                                    {/* <source src='http://192.168.1.6:8888/group1/M00/00/36/wKgBBmMEs8yEAQVXAAAAAJbLLMo254.mp4'type="video/mp4"/> */}
                                    
                                    {courseInfo.videoUrl ? <source src={courseInfo.videoUrl} type="video/mp4"/> : ''}

                                </video>
                                {/* {courseInfo.videoUrl} */}

                            </div>
                            <div className='videoInfo'>
                                <h2 style={{width:'90%'}}>{courseInfo.courseName}</h2>
                                <div>机构名称:{courseInfo.trainingName}</div>
                                <div>主讲教师:{courseInfo.jsName}</div>
                                <div>培训行业:{courseInfo.courseType}</div>
                                <div>联系方式:{courseInfo.courseTel}</div>
                                <Button onClick={this.props.history.goBack}>返回</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
